import { businessConnectionMst } from '@libs/domain';
import { businessConnectionType, eligibleBillingProvider } from '@libs/enums';
import { MstMaintenanceTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { AdditionalSearchBasicInfo, businessConnectionMstColumns } from './components';
import { businessConnectionMstListSearchFieldConfig } from './item-config';
import { BusinessConnectionMstListSearch } from './models';
import { doExport, listRequest, remove } from './repositories';

function PageComponent(props: PageProps) {
  return (
    <MstMaintenanceTmpl
      mstName={businessConnectionMst.labelNames.businessConnection}
      columns={businessConnectionMstColumns}
      items={businessConnectionMstListSearchFieldConfig}
      parsers={{
        eligibleBillingProviderCondition: eligibleBillingProvider.toDisplay,
        businessConnectionClass: businessConnectionType.toDisplay,
      }}
      listRequestFunction={listRequest}
      initMst={BusinessConnectionMstListSearch.init}
      exportFunction={doExport}
      deleteFunction={remove}
      {...props}
    >
      {AdditionalSearchBasicInfo}
    </MstMaintenanceTmpl>
  );
}

const Maintenance = withRerender(PageComponent, 'Maintenance');

export { Maintenance };
